// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_j6-0";
export var fulfillmentPanelBody = "_j6-1";